import { useState } from "react";
import { absoluteCenter } from "@/theme/utils/style";
import { Box, Button, Flex, Heading, Spinner, Text } from "@/ui";
import { t } from "@/utils";
import { useViewer } from "viewer/store/viewer";
import { getShouldCheckCameraAvailability } from "viewer/store/viewer/selectors";
import checkLocalDeviceAvailability from "viewer/modules/monitoring/utils/checkLocalDeviceAvailability";
import NavigationBar from "@/components/NavigationBar";
import Icon from "@/components/Icon";
import Lottie from "@/components/Lottie";
import ScanIcon from "assets/icons/scan.svg?react";
import onboarding3 from "assets/animations/onboarding3.lottie?url";
import { WizardProps } from "../Wizard";

export default function HowTo({ push }: WizardProps) {
  const [isChecking, setIsChecking] = useState(false);
  const shouldCheckCameraAvailability = useViewer(getShouldCheckCameraAvailability);

  const handleContinue = async () => {
    if (!shouldCheckCameraAvailability) {
      push("scan-code", { stepDirection: "next" });
      return;
    }

    setIsChecking(true);
    const cameraAvailability = await checkLocalDeviceAvailability("camera");
    if ("error" in cameraAvailability) {
      push("enter-code", { stepDirection: "next" });
      return;
    }

    push("scan-code", { stepDirection: "next" });
  };

  return (
    <Flex grow={1} direction="column" alignItems="center" minH={0}>
      <NavigationBar
        onBack={() => push("install-on-other-device", { stepDirection: "previous" })}
        props={{ my: "1rem", justifyContent: "center" }}
      >
        <Heading as="h6">{t("stepOf", { 0: 2, 1: 3 })}</Heading>
      </NavigationBar>
      <Flex grow={1} shrink={1} overflow="hidden">
        <Lottie src={onboarding3} textSlots={{ CameraStation: t("camera") }} />
      </Flex>
      <Flex direction="column" alignItems="center">
        <Text variant="title2" color="error" mt="24">
          {t("pairing.onSecondDevice")}
        </Text>
        <Heading as="h4" textAlign="center" px="32" mt="12">
          {t("pairing.add.camera.step2")}
        </Heading>
        <Text mt="0.75rem" textAlign="center">
          {t("scanQrCode")}
        </Text>
        <Button
          py="1.25rem"
          mt="24"
          mb="40"
          bg="primary"
          color="on-primary"
          minW="18.5rem"
          onClick={handleContinue}
          pos="relative"
          pointerEvents={isChecking ? "none" : "auto"}
        >
          <Flex alignItems="center" gap="0.75rem" opacity={isChecking ? 0 : 1}>
            <Icon icon={ScanIcon} fill="on-primary" />
            {t("scanCode")}
          </Flex>
          {isChecking && (
            <Box {...absoluteCenter}>
              <Spinner size="lg" color="surface" />
            </Box>
          )}
        </Button>
      </Flex>
    </Flex>
  );
}
